import { MainTableFilterModulesEnum } from '../enums/main-table-filter-modules.enum';
/* eslint-disable no-magic-numbers */
export const defaultPageIndex = 0;
export const defaultPageSizes = [5, 25, 50, 75, 100, 200];
export const defaultInitialPageSize = defaultPageSizes[1];
export const moduleDefaultPageSizes: { [key: string]: number } = {
  [MainTableFilterModulesEnum.MaintenanceJobs]: defaultInitialPageSize, // leaving this just in case we'll need to override defaults
};
